import 'jquery.easing';
import './plugins/utility';
import 'bootstrap/dist/js/bootstrap';
import INIT from './module/init';
import HOME from './module/home';
import FEATURE from './module/feature';
import PROJECT from './module/project';
import PRICE from './module/price';
import CONTACT from './module/contact';

INIT();

switch( location.pathname.replace(/^(\/[^/]+\/)(.*)?$/,'$1') ){
  case '/': HOME(); break
  case '/feature/': FEATURE(); break
  case '/project/': PROJECT(); break
  case '/price/': PRICE(); break
  case '/contact/': CONTACT(); break
  case '/download/': CONTACT(); break
}